// components/SuperAdminLayout.js
import React, { useState } from 'react';
import AdminSidebar from './AdminSidebar';
import { Outlet } from 'react-router-dom';
import TopBar from '../components/TopBar';

const AdminLayout = () => {
  const [sidebarExpanded, setSidebarExpanded] = useState(true);

  return (
    <div className="app">
      <AdminSidebar
        expanded={sidebarExpanded}
        toggleSidebar={() => setSidebarExpanded(!sidebarExpanded)}
      />
      <div className={`main-content-wrapper ${sidebarExpanded ? 'expanded' : 'collapsed'}`}>
        <nav className="topbar-wrapper">
          <TopBar />
        </nav>
        <main className="page-content custom-ak-scollbar">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
